module.exports = __webpack_public_path__ + "media/images/Results-At-Risk-5429cf1d99260a356c0e822cde32df5a.png";